import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { checkToken, getToken } from '../utils/nauth';

export const PrivateRoute = ({ children }: any) => {
  const { search } = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const ntokenParam = query.get('ntoken');

    if (ntokenParam) {
      // 로컬 개발: ?ntoken= → 쿠키에 저장
      checkToken(ntokenParam);
    } else if (!getToken()) {
      // 쿠키에 토큰 없음 → auth로 리다이렉트
      checkToken(null);
    }
  }, [search]);

  return children;
};

export default PrivateRoute;
